// extracted by mini-css-extract-plugin
module.exports = {"main":"ErrorPage_main__3iiok"};